var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M46.52,80.36c0-1.47,2.16-24.65,2.16-24.65L64.29,45.49",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.84,
    y1: 68.02,
    x2: 69.11,
    y2: 80.36,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.48,80.36c0-1.47-2.16-24.65-2.16-24.65L85.71,45.49",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.71 45.49 68.99 60.93 72.84 68.02 75 68.02 77.16 68.02 81.01 60.93 64.29 45.49",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.16,
    y1: 68.02,
    x2: 80.89,
    y2: 80.36,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.71,
    y1: 71.16,
    x2: 94.06,
    y2: 71.16,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 29.45,
    rx: 10.03,
    ry: 12.32,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.07,
    y1: 55.93,
    x2: 111.57,
    y2: 51.51,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.76,
    y1: 56.59,
    x2: 111.57,
    y2: 51.51,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.94,80.42c0-1-2.49-24.49-2.49-24.49L126,51.51",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "125.96 51.51 118.76 56.59 118.76 71.16",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.76,
    cy: 37.06,
    rx: 7.64,
    ry: 9.37,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.93,
    y1: 55.93,
    x2: 38.44,
    y2: 51.51,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.24,
    y1: 56.59,
    x2: 38.44,
    y2: 51.51,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,80.42c0-1,2.51-24.49,2.51-24.49L24,51.51",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24.04 51.51 31.24 56.59 31.24 71.16",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.24,
    cy: 37.06,
    rx: 7.64,
    ry: 9.37,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.42,80.36H13.58A12.47,12.47,0,0,0,1.11,92.83v40H26.66v-5.8A14.07,14.07,0,0,1,40.73,113h68.54a14.07,14.07,0,0,1,14.07,14.07v5.8h25.55v-40A12.47,12.47,0,0,0,136.42,80.36Z",
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.01,
    y1: 97.39,
    x2: 126.99,
    y2: 97.39,
    style: {
      fill: "none",
      stroke: "#223773",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "12.78843453502318px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.08888f43aa82b68c5f5dfdc11b726e08.svg";
export { ForwardRef as ReactComponent };